import { BlogItemGrid } from '@graphcommerce/next-ui'
import { Trans } from '@lingui/react'
import { Container, SxProps, Theme } from '@mui/material'
import { BlogItem } from '../Blog/BlogItem'
import { HobbyListQuery } from './HobbyList.gql'

type BlogListProps = {
  sx?: SxProps<Theme>
} & HobbyListQuery

export function HobbyList(props: BlogListProps) {
  const { hobbyPosts, sx = [] } = props

  return (
    <Container>
      <BlogItemGrid
        sx={[
          {
            gridTemplateColumns: {
              xs: `repeat(2, 1fr)`,
              md: `repeat(3, 1fr)`,
            },
            '& .BlogListItem-date': {
              display: 'none',
            },
            px: { xs: 0, sm: '40px', md: '80px', lg: '60px' },
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        {hobbyPosts.map((BlogPost) => (
          <BlogItem
            key={BlogPost.title}
            {...BlogPost}
            readMoreCaption={<Trans id="Let's get started" />}
          />
        ))}
      </BlogItemGrid>
    </Container>
  )
}
